export enum CurrentFlow {
  FinancialCheckup = 'FINANCIAL CHECKUP',
  DebtConsolidation = 'DEBT CONSOLIDATION',
  StudentLoanForgiveness = 'STUDENT LOAN FORGIVENESS',
  Card = 'CARD',
  AICoach = 'AI COACH',
}
